import "./SkipLink.scss";

export default function SkipLink() {
  return (
    <nav className="skip-links">
      <a
        href="https://ipc.nnphi.org/wp-content/uploads/2023/07/NNPHI_Scrolly2_Infographic-How-Dov-Viruses-Spread-508.pdf"
        className="skip"
        tabIndex={1}
        target="_blank"
        rel="noreferrer"
      >
        <span className="sr-only">
          This page is not compatible with screen readers.
        </span>
        &nbsp; Click <strong>here</strong> for an accessible PDF version of this
        infographic.
      </a>
      <p className="skip" tabIndex={2}>
        <span className="keyboardText">
          This page is not compatible with tab navigation. Keyboard users,
          progress through this interactive infographic using the up and down
          keys.
        </span>
      </p>
    </nav>
  );
}
